import React, { useEffect } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import { ReactComponent as SvgDecoratorBlob } from "images/svg-decorator-blob-6.svg";
import { ReactComponent as CheckboxIcon } from "images/checkbox-circle.svg";
import { ReactComponent as ArrowIcon } from "images/arrow-right-3-icon.svg";



const PlansContainer = tw.div`flex justify-between flex-col lg:flex-row items-center lg:items-stretch relative`;
const Plan = styled.div`
  ${tw`w-full max-w-sm mt-16 lg:mr-8 lg:last:mr-0 text-center px-8 rounded-lg shadow relative pt-2 text-gray-900 bg-white flex flex-col`}
  .planHighlight {
    ${tw`rounded-t-lg absolute top-0 inset-x-0 h-2`}
  }

  ${props =>
    props.featured &&
    css`
      background: rgb(100,21,255);
      background: linear-gradient(135deg, rgba(100,21,255,1) 0%, rgba(128,64,252,1) 100%);
background: rgb(85,60,154);
background: linear-gradient(135deg, rgba(85,60,154,1) 0%, rgba(128,90,213,1) 100%);
background: rgb(76,81,191);
background: linear-gradient(135deg, rgba(76,81,191,1) 0%, rgba(102,126,234,1) 100%);
      ${tw`bg-primary-500 text-gray-100`}
      .planHighlight {
        ${tw`hidden`}
      }
      .duration {
        ${tw`text-gray-200!`}
      }
      ${PlanFeatures} {
        ${tw`border-indigo-500`}
      }
      .feature:not(.mainFeature) {
        ${tw`text-gray-300!`}
      }
      ${BuyNowButton} {
        ${tw`bg-gray-100 text-primary-500 hocus:bg-gray-300 hocus:text-primary-800`}
    `}
`;

const PlanHeader = styled.div`
  ${tw`flex flex-col uppercase leading-relaxed py-8`}
  .name {
    ${tw`font-bold`}
  }
  .price {
    ${tw`font-bold my-1`}
  }
  .duration {
    ${tw`text-gray-500 font-bold tracking-widest`}
  }
`;
const PlanFeatures = styled.div`
  ${tw`flex flex-col -mx-8 px-8 py-8 border-t-2 border-b-2 flex-1`}
  .feature {
    ${tw`mt-5 first:mt-0 font-medium`}
    &:not(.mainFeature) {
      ${tw`text-gray-600`}
    }
  }
  .icon {
    ${tw`w-6 h-6 inline mr-1 text-primary-500 flex-shrink-0`}
  }
  .icon2 {
    ${tw`w-6 h-6 inline mr-1 text-yellow-500 flex-shrink-0`}
  }
`;

const PlanAction = tw.div`px-4 sm:px-8 xl:px-16 py-8`;
const BuyNowButton = styled(PrimaryButtonBase)`
  ${tw`rounded-full uppercase tracking-wider py-4 w-full text-sm hover:shadow-xl transform hocus:translate-x-px hocus:-translate-y-px focus:shadow-outline`}
`;

const DecoratorBlob = styled(SvgDecoratorBlob)`
  ${tw`pointer-events-none -z-20 absolute left-0 bottom-0 h-64 w-64 opacity-25 transform -translate-x-40 translate-y-1/2`}
`;
const DecoratorBlob2 = styled(SvgDecoratorBlob)`
  ${tw`pointer-events-none -z-20 absolute right-0 bottom-0 h-64 w-64 opacity-25 transform translate-x-20 translate-y-1/2`}
`;


export default ({ addRow = 0, plans = [], row2 = false, noBlob = false, wipes = true, showImg = false,
  primaryButtonText = "Dona"
}) => {

  const highlightGradientsCss = [
    css`
      background: rgb(171, 84, 46);
      background: linear-gradient(115deg, rgba(171, 84, 46, 1) 0%, rgba(173, 160, 154, 1) 100%);
    `,
    css`
      background: rgb(101, 121, 128);
      background: linear-gradient(115deg, rgba(101, 121, 128, 1) 0%, rgba(194, 203, 207, 1) 100%);
    `,
    css`
      background: rgb(204, 170, 59);
      background: linear-gradient(115deg, rgba(204, 170, 59, 1) 0%, rgba(207, 196, 161, 1) 100%);
    `
  ];

  const highlightGradientsCss2 = [
    css`
      background: rgb(156, 36, 36);
      background: linear-gradient(115deg, rgba(156, 36, 36, 1) 0%, rgba(254, 178, 178, 1) 100%);
    `,
    css`
      background: rgb(9, 110, 51);
      background: linear-gradient(115deg, rgba(9, 110, 51, 1) 0%, rgba(136, 184, 156, 1) 100%);
    `,
    css`
      background: rgb(0, 165, 201);
      background: linear-gradient(115deg, rgba(0, 165, 201, 1) 0%, rgba(149, 193, 201, 1) 100%);
    `
  ];

  return (
    <PlansContainer tw="justify-evenly">
      {plans.map((plan, index) => (
        <Plan key={index} featured={plan.featured} tw="justify-center">
          {!plan.featured && <div className="planHighlight" css={row2 ? highlightGradientsCss2[index % highlightGradientsCss2.length] : highlightGradientsCss[index % highlightGradientsCss.length]} />}
          <PlanHeader>
            {plan.featured ? <span className="name" tw="text-3xl text-gray-200">{plan.name}</span> : <span className="name" tw="text-3xl">{plan.name}</span>}
            {plan.price && plan.featured ? <span className="price" tw="text-3xl text-gray-500">{plan.price}</span> : <span className="price" tw="text-4xl">{plan.price}</span>}
            {plan.duration && plan.duration !== "Donazione singola" && <span className="duration">{plan.duration}</span>}
            {plan.duration === "Donazione singola" && <img src={require("../images/vehicles/veh-"+(parseInt(index)+parseInt(addRow))+".png").default} tw="pt-3" /> }
          </PlanHeader>
          {wipes === true && plan.features && <PlanFeatures>
            {plan.features.map((feature, index) => (
              <span key={index} className="feature">
                <CheckboxIcon className="icon" />{feature}
              </span>
            ))}
          </PlanFeatures>}
          {wipes === false && plan.features.map((feature, index) => (
              <span key={index} tw="font-medium text-lg text-gray-400 pb-6">
                <ArrowIcon tw="w-6 h-6 inline mr-1 mb-2 text-yellow-500 flex-shrink-0" />{feature}
              </span>
            ))}
          {showImg && <img src={require("../images/house-"+index+".png").default} tw="pb-6" /> }
          {plan.duration && <PlanAction tw="flex items-end">
            <BuyNowButton css={!plan.featured && (row2 ? highlightGradientsCss2[index] : highlightGradientsCss[index])}>{primaryButtonText}</BuyNowButton>
          </PlanAction>}
        </Plan>
      ))}
      {noBlob === false && row2 === false && <DecoratorBlob />}
      {noBlob === false && row2 === true && <DecoratorBlob2 />}
    </PlansContainer>
  );
};
